import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import Button from 'flarum/common/components/Button';
function toPoll(data) {
  if (data) {
    const poll = app.store.createRecord('polls');
    poll.tempOptions = data.options.map(option => {
      const pollOption = app.store.createRecord('poll_options');
      pollOption.pushAttributes(option);
      return pollOption;
    });
    poll.pushAttributes(data);
    return poll;
  }
  return data;
}
function addPoll(composer) {
  app.modal.show(() => import(/* webpackChunkName: 'forum/components/CreatePollModal', webpackMode: 'lazy-once' */ './components/CreatePollModal'), {
    poll: toPoll(composer.composer.fields.poll),
    onsubmit: poll => composer.composer.fields.poll = poll
  });
}
export const addToComposer = composerPath => {
  // Add button to composer header
  extend(composerPath, 'headerItems', function (items) {
    var _this$composer$body, _discussion$canStartP;
    const discussion = (_this$composer$body = this.composer.body) == null || (_this$composer$body = _this$composer$body.attrs) == null ? void 0 : _this$composer$body.discussion;
    const canStartPoll = (_discussion$canStartP = discussion == null ? void 0 : discussion.canStartPoll()) != null ? _discussion$canStartP : app.forum.attribute('canStartPolls');
    if (canStartPoll) {
      items.add('polls', m(Button, {
        className: "ComposerBody-poll Button Button--ua-reset",
        onclick: () => addPoll(this)
      }, m("span", {
        className: classList('PollLabel', !this.composer.fields.poll && 'none')
      }, app.translator.trans("fof-polls.forum.composer_discussion.".concat(this.composer.fields.poll ? 'edit' : 'add', "_poll")))), 1);
    }
  });
  extend(composerPath, 'data', function (data) {
    if (this.composer.fields.poll) {
      data.poll = this.composer.fields.poll;
    }
  });
};
export default () => {
  addToComposer('flarum/forum/components/DiscussionComposer');
  addToComposer('flarum/forum/components/ReplyComposer');
};flarum.reg.addChunkModule('966', '5610', 'fof-polls', 'forum/components/CreatePollModal');